import { useEffect } from "react";
import { useFormData } from "@/stores/formStore";

/**
 * If the persisted occupation isn't present in the supplied era-specific
 * occupations list, clear it (and any dependent skill/specialization fields)
 * so the flow can't get stuck on an invalid occupation after switching eras.
 *
 * Pass `isLoading` to avoid clearing while the list is still loading.
 */
export const useResetInvalidOccupation = (
  occupations: string[] | undefined,
  isLoading: boolean,
  onCleared?: () => void,
) => {
  const {
    formData,
    updateDetails,
    updateOccupationSkills,
    updatePersonalSkills,
    updateSpecializationInputs,
  } = useFormData();

  useEffect(() => {
    if (isLoading) return;
    if (!occupations || occupations.length === 0) return;
    const current = formData.details.occupation;
    if (!current) return;
    if (occupations.includes(current)) return;

    updateDetails({ occupation: "" });
    updateOccupationSkills({});
    updatePersonalSkills({});
    updateSpecializationInputs({});
    onCleared?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [occupations, isLoading]);
};